import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import toast from 'react-hot-toast';
import { Eye, EyeOff, Users } from 'lucide-react';

export default function TmLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const { login, loading, user } = useAuth();
  const navigate = useNavigate();

  // If already logged in, redirect to TM
  if (user) {
    navigate('/tm/tasks', { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await login(username, password);
      // Store that user logged in via team-login
      localStorage.setItem('tm_login_source', 'team');
      toast.success('مرحباً بك في إدارة الفرق!');
      navigate('/tm/tasks');
    } catch (err) {
      toast.error(err.response?.data?.error || 'فشل تسجيل الدخول');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#0a0f1a] font-[Tajawal]" dir="rtl">
      {/* Background effects */}
      <div className="absolute top-[-15%] right-[-10%] w-[600px] h-[600px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)' }} />
      <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(139,92,246,0.06) 0%, transparent 70%)' }} />
      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

      <div className="w-full max-w-[440px] relative z-10 px-4">
        <div className="bg-white/[0.03] backdrop-blur-xl rounded-[24px] p-10 md:p-12 shadow-[0_20px_60px_rgba(0,0,0,0.4)] border border-white/[0.06] transition-all">

          {/* Logo */}
          <div className="text-center mb-10">
            <div className="mb-5 flex justify-center">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-600 to-purple-600 flex items-center justify-center shadow-lg shadow-blue-500/20">
                <Users size={32} className="text-white" />
              </div>
            </div>
            <h1 className="text-3xl font-black tracking-widest text-gray-100 m-0">
              MS <span className="text-blue-400">MEDIA</span>
            </h1>
            <p className="mt-2 text-sm text-gray-400 tracking-wide">
              إدارة الفرق
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* username */}
            <div>
              <label className="block text-sm font-bold text-gray-300 mb-2">اسم المستخدم</label>
              <input
                type="text"
                value={username} onChange={e => setUsername(e.target.value)}
                placeholder="username"
                autoComplete="username"
                className="w-full py-3.5 px-4 bg-white/[0.04] text-gray-100 rounded-xl border-2 border-white/[0.08] focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all outline-none placeholder-gray-600"
              />
            </div>

            {/* password */}
            <div>
              <label className="block text-sm font-bold text-gray-300 mb-2">كلمة المرور</label>
              <div className="relative">
                <input
                  type={showPass ? 'text' : 'password'}
                  value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  className="w-full py-3.5 px-4 pl-12 bg-white/[0.04] text-gray-100 rounded-xl border-2 border-white/[0.08] focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 transition-all outline-none placeholder-gray-600"
                />
                <button type="button" onClick={() => setShowPass(!showPass)} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-blue-400 transition-colors">
                  {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} className={`w-full py-3.5 mt-2 rounded-xl font-bold text-white transition-all shadow-lg ${loading ? 'bg-gray-600 cursor-not-allowed opacity-70 shadow-none' : 'bg-gradient-to-l from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 hover:-translate-y-0.5 shadow-blue-600/25'}`}>
              {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-gray-600 text-xs">© MS Media 2026</p>
          </div>

        </div>
      </div>
    </div>
  );
}
